import { render, staticRenderFns } from "./YpoImageWithLoader.vue?vue&type=template&id=777faa55&"
import script from "./YpoImageWithLoader.vue?vue&type=script&lang=js&"
export * from "./YpoImageWithLoader.vue?vue&type=script&lang=js&"
import style0 from "./YpoImageWithLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports